(function () {
  const FAQ_SECTION = document.getElementById('faq-component-section');
  if (!FAQ_SECTION) return;

  // Animate open: set explicit height for CSS transition, then clear to 'auto'
  function openPanel(panel) {
    panel.style.height = panel.scrollHeight + 'px';
    panel.addEventListener(
      'transitionend',
      function onOpen() {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', onOpen);
      },
      { once: true }
    );
  }

  // Animate close: snapshot current height, then collapse to 0
  function closePanel(panel) {
    panel.style.height = panel.scrollHeight + 'px';
    // Force reflow so the browser registers the explicit height before transitioning
    panel.getBoundingClientRect();
    panel.style.height = '0';
  }

  function toggleItem(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const panelId    = button.getAttribute('aria-controls');
    const panel      = document.getElementById(panelId);
    if (!panel) return;

    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      closePanel(panel);
    } else {
      button.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      openPanel(panel);
    }
  }

  // Initial state — ensure all panels start collapsed
  FAQ_SECTION.querySelectorAll('collapsible-content').forEach(function (panel) {
    panel.style.height   = '0';
    panel.style.overflow = 'hidden';
    panel.setAttribute('aria-hidden', 'true');
  });

  FAQ_SECTION.addEventListener('click', function (e) {
    const button = e.target.closest('[is="toggle-button"]');
    if (!button) return;
    toggleItem(button);
  });
})();